export const keys = {
    all: ["manual-entry"],
    tagManualEntries: () => [
        ...keys.all,
        "tagmanualentryvalues"
    ],
    tagManualEntryValues:(groupID: number, tagID: number, startDate: Date | undefined, endDate: Date | undefined) => [
        ...keys.tagManualEntries(),
        {
            groupID,
            tagID,
            startDate,
            endDate
        }
    ],
    groupManualEntries: () => [
        ...keys.all,
        "groupmanualentryvalues"
    ],
    groupManualEntryValues:(groupID: number, date: Date) => [
        ...keys.groupManualEntries(),
        {
            groupID,
            date
        }
    ]
}